import { render, staticRenderFns } from "./ProductTX.vue?vue&type=template&id=e46ed572&scoped=true&"
import script from "./ProductTX.vue?vue&type=script&lang=js&"
export * from "./ProductTX.vue?vue&type=script&lang=js&"
import style0 from "./ProductTX.vue?vue&type=style&index=0&id=e46ed572&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e46ed572",
  null
  
)

export default component.exports